import { Helmet } from "react-helmet-async";

import { adsConfig } from "@/config/ads.config";
import { useCookieConsent } from "@/hooks/useCookieConsent";

export function AdSenseScript() {
  const { accepted } = useCookieConsent();

  if (!adsConfig.enabled || !adsConfig.client || !accepted) {
    return null;
  }

  return (
    <Helmet>
      <script
        async
        src={`https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${adsConfig.client}`}
        crossOrigin="anonymous"
      />
    </Helmet>
  );
}
